
export class TagModel {
  Tag: string;
  Matricula: string;
}
